import { Link, useParams, useNavigate } from 'react-router-dom';
import apiMethod from '../../../services/api-service';
import methods from '../../../services/utility';
import { useState, useEffect } from 'react';

// assets
import back from "../../../assets/images/icons/arrow-right2.svg";
import Preloading from '../../../components/basics/Preloading';
import DeleteModalSnapp from '../../../components/deleteModal/DeleteModalSnapp';

const SnappToppings = () => {
  const { branchId, unitId, categoryId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [gridData, setGridData] = useState([]);
  const [gridFilter, setGridFilter] = useState({
    branchId: branchId,
    unitId: unitId,
    categoryId: categoryId,
    size: 20,
    part: 1,
    title: '',
    total: 0,
    parts: 0
  });
  const [snappSecurity, setSnappSecurity] = useState({
    vendorCode: "",
    snappToken: ""
  });
  const [formModel, setFormModel] = useState({
    id: 0,
    title: "",
    price: 0,
    containerPrice: 0,
    saleMenuId: 0,
    snappCategoryId: categoryId,
    saleUnitId: unitId,
    branchId: branchId,
    vendorCode: "",
    snappToken: ""
  });
  const [saleMenus, setSaleMenus] = useState([]);
  const [saleMenuFilter, setSaleMenuFilter] = useState({
    branchId: branchId,
    unitId: unitId,
    menuType: 1,
    categoryId: 0,
    size: 20,
    part: 1,
    title: '',
    total: 0,
    parts: 0
  });

  const [snappCategory, setSnappCategory] = useState({
    id: 0,
    unitId: unitId,
    categoryId: 0,
    size: 20,
    part: 1,
    title: ''
  });

  const [showModal, setShowModal] = useState(false);
  const [showMenuSearch, setShowMenuSearch] = useState(true);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [pageTitle, setPageTitle] = useState("");


  const mapModel = (model) => {
    formModel.id = model.id;
    formModel.title = model.title;
    formModel.price = model.price;
    formModel.containerPrice = model.containerPrice;
    formModel.saleMenuId = model.saleMenuId;
    formModel.snappCategoryId = model.snappCategoryId;
    formModel.saleUnitId = model.saleUnitId;
    formModel.branchId = model.branchId;
    formModel.vendorCode = snappSecurity.vendorCode;
    formModel.snappToken = snappSecurity.snappToken;
    setFormModel({ ...formModel });
  };

  const getGridData = async (showLoading) => {
    if (showLoading)
      setLoading(true);
    const response = await apiMethod.getSnappToppings(gridFilter.branchId, gridFilter.unitId, gridFilter.categoryId, gridFilter.title, gridFilter.part, gridFilter.size);
    if (showLoading)
      setLoading(false);
    if (methods.showApiErrors(response)) {
      gridFilter.total = response.total;
      gridFilter.parts = methods.calcPageParts(response.total, gridFilter.size);
      setGridFilter({ ...gridFilter });
      setGridData(response.data);
    }
  };

  const getSnappCategoryInfo = async () => {
    const response = await apiMethod.getCategoryInfo(categoryId);
    if (!methods.showApiErrors(response))
      return false;
    snappCategory.menuCategoryId = response.data.menuCategoryId;
    setSnappCategory(response.data);
    setPageTitle(response.data.title);

  };

  const getSaleMenus = async (showLoading) => {
    if (showLoading)
      setLoading(true);

    saleMenuFilter.categoryId = snappCategory.menuCategoryId;
    const response = await apiMethod.findSaleMenusForSnapp(saleMenuFilter.branchId, saleMenuFilter.unitId, saleMenuFilter.menuType, saleMenuFilter.categoryId, saleMenuFilter.size, saleMenuFilter.part, saleMenuFilter.title);
    if (showLoading)
      setLoading(false);
    if (methods.showApiErrors(response)) {
      saleMenuFilter.total = response.total;
      saleMenuFilter.parts = methods.calcPageParts(response.total, saleMenuFilter.size);
      setSaleMenuFilter({ ...saleMenuFilter });
      setSaleMenus(response.data);
    }
  };

  const setSnappToken = async () => {
    const response = await apiMethod.getSnappToken(branchId, unitId);
    if (!methods.showApiErrors(response))
      return false;
    snappSecurity.snappToken = response.data.token;
    snappSecurity.vendorCode = response.data.clientId;
    setSnappSecurity(snappSecurity);
    setFormModel(formModel);
  };

  useEffect(() => {
    const bindData = async () => {
      setLoading(true);
      await getSnappCategoryInfo();
      await getGridData(false);
      await setSnappToken();
      await getSaleMenus(false);
      setLoading(false);
    }
    bindData();
  }, [branchId]);

  const resetForm = () => {
    mapModel({
      id: 0,
      title: "",
      price: 0,
      containerPrice: 0,
      saleMenuId: 0,
      snappCategoryId: categoryId,
      saleUnitId: unitId,
      branchId: branchId,
      vendorCode: formModel.vendorCode,
      snappToken: formModel.snappToken
    });
    setShowModal(false);
    setShowDeleteModal(false);
    setShowMenuSearch(true);
  };

  const getItemInfo = async (id) => {
    setLoading(true);
    const response = await apiMethod.getToppingInfo(id);
    if (!methods.showApiErrors(response))
      return false;

    mapModel(response.data);
    setShowMenuSearch(false);
    setShowModal(true);
    setLoading(false);
  };

  const normalizeModel = () => {
    formModel.snappToken = snappSecurity.snappToken;
    formModel.vendorCode = snappSecurity.vendorCode;
    setFormModel({ ...formModel });
  };

  const createItem = async () => {
    normalizeModel();
    if (!isValidForm())
      return false;

    setLoading(true);

    try {
      const resp = await apiMethod.createTopping(formModel);

      if (!methods.showApiErrors(resp))
        return false;

      await getGridData();

    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setShowModal(false);
    }
  };

  const setMenu = (menu) => {
    formModel.title = menu.title;
    formModel.saleMenuId = menu.id;
    formModel.price = parseInt(menu.price / 10);
    formModel.containerPrice = parseInt(menu.packagingPrice / 10);
    setFormModel({ ...formModel });
    setShowMenuSearch(false);
  };

  const changeMenuItem = (menuId) => {
    var saleMenuId = parseInt(menuId);
    var menu = saleMenus.find(x => x.id === saleMenuId);
    setMenu(menu);
  };

  const isValidForm = () => {
    var errors = [];
    if (methods.isNullOrEmptyString(formModel.title)) {
      errors.push('عنوان محصول باید مقدار داشته باشد.');
    }
    if (methods.isNullOrEmptyString(formModel.saleMenuId === 0)) {
      errors.push('منو باید انتخاب شده باشد.');
    }
    if (methods.isNullOrEmptyString(formModel.price) || formModel.price === 0) {
      errors.push('قیمت محصول باید مقدار داشته باشد.');
    }
    if (methods.isNullOrEmptyString(formModel.containerPrice)) {
      errors.push('هزینه ظرف باید مقدار داشته باشد.');
    }
    if (errors.length > 0) {
      methods.showErrors(errors);
      return false;
    }

    return true;
  };

  const resetFilters = () => {
    gridFilter.branchId = branchId;
    gridFilter.unitId = unitId;
    gridFilter.title = '';
    gridFilter.size = 20;
    gridFilter.part = 1;
    setGridFilter({ ...gridFilter })
  };

  const searchItem = async () => {
    setLoading(true);
    await getGridData();
    setLoading(false);
  };

  const clearSearch = async () => {
    setLoading(true);
    resetFilters();
    await getGridData();
    setLoading(false);
  };

  const callPager = async (i) => {
    setLoading(true);
    gridFilter.part = i;
    setGridFilter({ ...gridFilter });
    await getGridData();
    setLoading(false);
  };

  const movePagerPart = (isForward) => {
    if (isForward) {
      if (gridFilter.parts < gridFilter.part + 1) {
        return false;
      }
      callPager(gridFilter.part + 1);
    } else {
      if (gridFilter.part === 1) {
        return false;
      }
      callPager(gridFilter.part - 1);
    }
  };

  const makePagerItems = () => {
    let pages = [];
    for (let i = 1; i <= gridFilter.parts; i++) {
      pages.push(
        <li key={i} className={gridFilter.part === i ? 'page-item active mx-1' : 'page-item mx-1'}>
          <a className="page-link circular-pagination" onClick={() => { callPager(i) }}>
            {i}
          </a>
        </li>
      );
    }
    return pages;
  };

  const resetSaleMenuFilter = () => {
    saleMenuFilter.branchId = branchId;
    saleMenuFilter.unitId = unitId;
    saleMenuFilter.title = '';
    saleMenuFilter.size = 20;
    saleMenuFilter.part = 1;
    setSaleMenuFilter({ ...saleMenuFilter })
  };

  const searchSaleMenuItem = async () => {
    setLoading(true);
    await getSaleMenus();
    setLoading(false);
  };

  const clearSaleMenuSearch = async () => {
    setLoading(true);
    resetSaleMenuFilter();
    await getSaleMenus();
    setLoading(false);
  };

  const SaleMenuCallPager = async (i) => {
    setLoading(true);
    saleMenuFilter.part = i;
    setSaleMenuFilter({ ...saleMenuFilter });
    await getSaleMenus();
    setLoading(false);
  };

  const SaleMenuMovePagerPart = (isForward) => {
    if (isForward) {
      if (saleMenuFilter.parts < saleMenuFilter.part + 1) {
        return false;
      }
      SaleMenuCallPager(saleMenuFilter.part + 1);
    } else {
      if (saleMenuFilter.part === 1) {
        return false;
      }
      SaleMenuCallPager(saleMenuFilter.part - 1);
    }
  };

  const SaleMenuMakePagerItems = () => {
    let pages = [];
    for (let i = 1; i <= saleMenuFilter.parts; i++) {
      pages.push(
        <li key={i} className={saleMenuFilter.part === i ? 'page-item active mx-1' : 'page-item mx-1'}>
          <a className="page-link circular-pagination" onClick={() => { SaleMenuCallPager(i) }}>
            {i}
          </a>
        </li>
      );
    }
    return pages;
  };

  const switchToAllCategoriesView = () => {
    setShowMenuSearch(true);
  };

  const openNewForm = async () => {
    resetForm();
    setShowModal(true);
  };

  const closeModal = () => {
    resetForm();
    setShowModal(false);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const selectَSanpToDelete = (snap) => {
    setFormModel(snap);
    setShowDeleteModal(true);
  };

  const deleteItem = async () => {
    setLoading(true);
    try {
      const resp = await apiMethod.removeMenuSnapp(formModel.id);
      if (!methods.showApiErrors(resp))
        return false;

      await getGridData();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setShowDeleteModal(false);
    }
    return true;
  };

  const renderItems = () => {
    return (
      <>
        {loading && <Preloading></Preloading>}
        {
          <>
            <div>
              <Link to={`/sale/${branchId}/snappManager/ToppingCategories/${unitId}`} className='d-none d-lg-block text-start mb-3 link back-link'>
                <span><img src={back} className="" alt="return" /></span>
                بازگشت
              </Link>
            </div>
            <div className='d-lg-none d-flex justify-content-between align-items-baseline saleheader'>
              <div>
                <Link to={`/sale/${branchId}/snappManager`} className='link back-link'>
                  <span><img src={back} className="" alt="return" /></span>
                </Link>
                محصولات دسته‌بندی/ {pageTitle}
              </div>
              <p className="date">{methods.currentDate()}</p>
            </div>
            <div className='saleheader d-none d-lg-block'>
              <p> محصولات دسته‌بندی/ {pageTitle}</p>
            </div>
            <div className="salemain">
              <div className='salesearchsection'>
                <div className='row g-1'>
                  <div className='col-12 col-md-6 col-lg-4'>
                    <label htmlFor="funit" className="form-label">عنوان</label>
                    <div className="hstack">
                      <input
                        id="searchInput"
                        className="form-control"
                        type="text"
                        aria-label="Add your item here..."
                        style={{ direction: 'rtl', textAlign: 'right' }}
                        value={gridFilter.title}
                        onChange={(e) => { setGridFilter({ ...gridFilter, title: e.target.value, part: 1 }) }}
                      />
                      <button type='button' className='btn btn-purple me-1'
                        onClick={searchItem}
                      >
                        <i className="bi bi-search"></i>
                      </button>
                      <button type='button' className='btn btn-outline-info'
                        onClick={clearSearch}
                      >
                        <i className="bi bi-arrow-clockwise"></i>
                      </button>
                    </div>
                  </div>
                  <div className='col-12 col-md-2 col-lg-4'></div>
                  <div className='col-12 col-md-4'>
                    <div className='createButton'>
                      <button
                        onClick={() => { openNewForm() }}
                        className='btn btn-outline-purple custome-btn' type='button'>
                        <span className='align-middle d-inline-block'>ایجاد محصول</span> <i className="bi bi-plus-circle align-middle"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className='table-responsive saletable'>
                <table className="table table-striped table-md " >
                  <thead className='align-middle'>
                    <tr>
                      <th scope="col vertical-center" width="20px">ردیف</th>
                      <th scope="col vertical-center">عنوان</th>
                      <th scope="col vertical-center">قیمت</th>
                      <th scope="col vertical-center">هزینه ظرف</th>
                      <th scope="col vertical-center">اتصال اسنپ</th>
                      <th scope="col vertical-center" width="100px">عملیات</th>
                    </tr>
                  </thead>
                  <tbody className='align-middle'>
                    {gridData.map((item, index) => (
                      <tr key={item.id}>
                        <th scope="row">{((gridFilter.part - 1) * gridFilter.size) + index + 1}</th>
                        <td>{item.title}</td>
                        <td>{methods.addNumSeperator(item.price)}</td>
                        <td>{methods.addNumSeperator(item.containerPrice)}</td>
                        <td>
                          {item.snappGroupSyncId > 0 &&
                            <>
                              <span className='text-success'>متصل</span>
                            </>
                          }
                          {item.snappGroupSyncId === 0 &&
                            <>
                              <span className='text-danger'>عدم اتصال</span>
                            </>
                          }
                        </td>
                        <td>
                          <button
                            onClick={() => getItemInfo(item.id)}
                            className='btn btn-sm btn-outline-purple me-2' type='button'>
                            <i className="bi bi-pencil-square"></i>
                          </button>
                          <button
                            onClick={() => selectَSanpToDelete(item)}
                            className='btn btn-sm btn-outline-danger' type='button'>
                            <i className="bi bi-trash"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {gridFilter.parts > 1 &&
                  <nav aria-label="Page navigation example" className='mt-5'>
                    <ul className="pagination justify-content-center">
                      <li className="page-item mx-1">
                        <a className="page-link circular-pagination" onClick={() => { movePagerPart(false) }}>
                          <i className="bi bi-chevron-compact-right"></i>
                        </a>
                      </li>
                      {makePagerItems()}
                      <li className="page-item mx-1">
                        <a className="page-link circular-pagination" onClick={() => { movePagerPart(true) }}>
                          <i className="bi bi-chevron-compact-left"></i>
                        </a>
                      </li>
                    </ul>
                  </nav>
                }
              </div>
            </div>
          </>
        }
      </>
    )
  };

  const Modal = () => {
    return (
      <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: showModal ? 'block' : 'none' }}>
        <div className="modal-dialog modal-lg" role="document" >
          <div className="modal-content px-3">
            <div className="modal-header">
              <h5 className="modal-title">ایجاد / ویرایش منوی اسنپ</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={closeModal}
              >
              </button>
            </div>
            <div className="modal-body">
              {showMenuSearch && (
                <>
                  <div className='col-md-6'>
                    <label htmlFor="funit" className="form-label">جستجو در منوهای‌دسته</label>
                    <div className="hstack">
                      <input
                        id="searchInput"
                        className="form-control"
                        type="text"
                        aria-label="Add your item here..."
                        style={{ direction: 'rtl', textAlign: 'right' }}
                        value={saleMenuFilter.title}
                        onChange={(e) => { setSaleMenuFilter({ ...saleMenuFilter, title: e.target.value, part: 1 }) }}
                      />
                      <button type='button' className='btn btn-purple me-1'
                        onClick={searchSaleMenuItem}
                      >
                        <i className="bi bi-search"></i>
                      </button>
                      <button type='button' className='btn btn-outline-info'
                        onClick={clearSaleMenuSearch}
                      >
                        <i className="bi bi-arrow-clockwise"></i>
                      </button>
                    </div>
                  </div>
                  <div className='border rounded mt-4'>
                    <p className='bg-light rounded-top p-3'>انتخاب منوهای دسته</p>
                    <div className='table-responsive saletable m-3'>
                      <table className="table table-striped table-md align-middle" >
                        <thead className=''>
                          <tr>
                            <th scope="col vertical-center" width="20px">ردیف</th>
                            <th scope="col vertical-center">عنوان</th>
                            <th scope="col vertical-center">دسته بندی</th>
                            <th scope="col vertical-center" width="50px">عملیات</th>
                          </tr>
                        </thead>
                        <tbody className=''>
                          {saleMenus.filter(x => !x.isExist).map((item, index) => (
                            <tr key={item.id}>
                              <th scope="row">{((saleMenuFilter.part - 1) * saleMenuFilter.size) + index + 1}</th>
                              <td>{item.title}</td>
                              <td>{item.categoryTitle}</td>
                              <td>
                                <button type="button" className="btn btn-sm btn-purple"
                                  onClick={() => setMenu(item)}
                                >
                                  افزودن
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      {saleMenuFilter.parts > 1 &&
                        <nav aria-label="Page navigation example" className='mt-5'>
                          <ul className="pagination justify-content-center">
                            <li className="page-item mx-1">
                              <a className="page-link circular-pagination" onClick={() => { SaleMenuMovePagerPart(false) }}>
                                <i className="bi bi-chevron-compact-right"></i>
                              </a>
                            </li>
                            {SaleMenuMakePagerItems()}
                            <li className="page-item mx-1">
                              <a className="page-link circular-pagination" onClick={() => { SaleMenuMovePagerPart(true) }}>
                                <i className="bi bi-chevron-compact-left"></i>
                              </a>
                            </li>
                          </ul>
                        </nav>
                      }
                    </div>
                  </div>
                </>
              )}
              {!showMenuSearch && (
                <>
                  <div className='mb-4'>
                    <Link
                      onClick={switchToAllCategoriesView}
                      className='link back-link'
                    >
                      <span><img src={back} className="" alt="return" /></span>
                      بازگشت
                    </Link>
                  </div>
                  <div className="row g-3" autoComplete="off">
                    <div className="col-md-6">
                      <label htmlFor="title" className="form-label required-label">عنوان</label>
                      <input type="text" className="form-control" id="title" name="title"
                        value={formModel.title}
                        onChange={(e) => {
                          formModel.title = e.target.value;
                          setFormModel({ ...formModel });
                        }}
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="ddlMenu" className="form-label required-label">منوی متصل</label>
                      <select
                        id="ddlMenu"
                        className="form-select"
                        aria-label="menu"
                        value={formModel.saleMenuId}
                        onChange={(e) => {
                          changeMenuItem(e.target.value);
                        }}
                      >
                        {saleMenus.map((item, index) => (
                          <option value={item.id} key={index}>{item.title}</option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor="price" className="form-label required-label">قیمت</label>
                      <input type="text" className="form-control" id="price"
                        value={methods.addNumSeperator(formModel.price)}
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          const price = parseInt(inputValue.replace(/,/g, ''));
                          setFormModel({ ...formModel, price: isNaN(price) ? '' : price });
                        }}
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor="containerPrice" className="form-label required-label">هزینه ظرف </label>
                      <input type="text" className="form-control" id="containerPrice"
                        value={methods.addNumSeperator(formModel.containerPrice)}
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          const containerPrice = parseInt(inputValue.replace(/,/g, ''));
                          setFormModel({ ...formModel, containerPrice: isNaN(containerPrice) ? '' : containerPrice });
                        }}
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
            <div className="modal-footer d-inline-flex d-lg-flex">
              <button type="button" className="btn custome-btn btn-link-purple" onClick={closeModal}>
                انصراف
              </button>
              <button type="button"
                onClick={() => { createItem() }}
                className="btn custome-btn btn-purple w-25 ">ذخیره</button>
            </div>
          </div >
        </div >
      </div >
    )
  };

  return (
    <>
      {renderItems()}
      {showModal && Modal()}
      {showDeleteModal &&
        <DeleteModalSnapp
          showModal={showDeleteModal}
          closeModal={closeDeleteModal}
          deleteItem={deleteItem}
          text={'دسته‌بندی'}
        />
      }
    </>
  );
}

export default SnappToppings;